__turbopack_context__.v({
  "content": "IjIO1G_content",
  "tab": "IjIO1G_tab",
  "tabIcon": "IjIO1G_tabIcon",
  "tabLabel": "IjIO1G_tabLabel",
  "tray": "IjIO1G_tray",
});
